import { Button } from '@/components/base/button'
import { Dialog, DialogActions, DialogBody, DialogTitle, ShowProps } from '@/components/base/dialog'
import { useEffect, useState } from 'react'
import { DocumentTypeQuery } from './__generated__/show_query'
import { Query } from './show_query'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { DeleteDialog } from '@/components/delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { Query as TableQuery } from './table_query'
import { EditDialog } from './edit_dialog'
import { SubjectBadge } from './badge'
import { Accordion } from '../accordion'
import { Table as DocumentsTable } from '@/components/document/table'

type DocumentType = DocumentTypeQuery['documentTypes']['nodes'][0]

export const ShowDialog = ({ id, open, setOpen }: ShowProps) => {
  const [openEdit, setOpenEdit] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [documentType, setDocumentType] = useState<DocumentType | null>(null)

  const { data, loading, error } = useQuery<DocumentTypeQuery>(Query, { variables: { filters: { idEq: id } } })

  useEffect(() => {
    if (!data || !id) return

    setDocumentType(data.documentTypes.nodes[0])
  }, [id, data])

  const onEdit = () => {
    setOpenEdit(true)
  }

  const onDelete = () => {
    setOpenDelete(true)
  }

  const onDeleteSuccess = () => {
    setOpenDelete(false)
    setOpen(false)
  }

  return (
    <>
      <Dialog open={open} size="7xl" onClose={setOpen}>
        <DialogTitle>
          {
            loading || !documentType
              ? <Loading />
              : <div className="flex flex-row justify-between">
                <div>
                  <span className="flex flex-row gap-4 items-center pb-6">
                    { documentType.name }
                    <SubjectBadge subject={documentType.subject} />
                  </span>
                </div>
              </div>
          }
        </DialogTitle>
        <DialogBody>
          { error && <Error message={error.message} />}
          { documentType && <div className="flex flex-col gap-4">
            <Accordion title="Documents" defaultOpen>
              <DocumentsTable filters={{ documentTypeIdEq: documentType.id }} pageSize={5} fixedHeight />
            </Accordion>
          </div> }
        </DialogBody>
        <DialogActions>
          { documentType && <Button color="amber" onClick={onEdit}>Edit</Button> }
          { documentType && <Button color="red" onClick={onDelete}>Delete</Button> }
        </DialogActions>
      </Dialog>
      { documentType && <EditDialog id={documentType.id} open={openEdit} setOpen={setOpenEdit} /> }
      {
        documentType &&
          <DeleteDialog
            id={documentType.id}
            mutation={DeleteMutation}
            open={openDelete}
            refetchQueries={[TableQuery]}
            setOpen={setOpenDelete}
            onSuccess={onDeleteSuccess}
          />
      }
    </>
  )
}
